import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./rules-editor-toolbar.module.scss";
import IconChevronLeft from "../../../dynamicicons/icon-chevron-left";
import VelavuButton from "../../../elements/velavu-button";
import { classArr } from "../../../helper/style-helper";
import VelavuSavedIndicator from "../../../elements/velavu-saved-indicator";

export type RulesEditorToolbarPropsSaveState =
	"disabled" | "enabled" | "saving" | "saved";

export interface RulesEditorToolbarProps {
	className?: string;
	onBack?: () => void;
	saveState?: RulesEditorToolbarPropsSaveState;
	onSave?: () => void;
	saveTooltip?: string;
}

/**
 * A toolbar displayed at the top of the rules editor sidebar
 */
export default function RulesEditorToolbar(props: RulesEditorToolbarProps) {
	const { t } = useTranslation();

	return (
		<div className={classArr(styles.container, props.className)}>
			<VelavuButton
				className={styles.backButton}
				label={t("common.back")}
				variant="outlined"
				icon={(size, color, className) => (
					<IconChevronLeft
						size={size}
						color={color}
						className={className}
					/>
				)}
				onClick={props.onBack}
			/>

			<span className={styles.title}>
				{t("rules.editor.rule_details")}
			</span>

			{props.saveState === "saved" ? (
				<VelavuSavedIndicator className={styles.saveButton} />
			) : (
				<VelavuButton
					className={styles.saveButton}
					label={t("common.save")}
					loadingIndicator={props.saveState === "saving"}
					disabled={
						props.saveState === "saving" ||
						props.saveState === "disabled"
					}
					tooltip={props.saveTooltip}
					onClick={props.onSave}
				/>
			)}
		</div>
	);
}
